export default "__VITE_ASSET__5628394a__"